import RewardsSearchV2 from './RewardsSearchV2';

export default RewardsSearchV2;
